<template>
    <div class="flex items-center justify-center min-h-screen bg-muted">
        <router-view />
    </div>
</template>

<script lang="ts" setup>
</script>
